import { Injectable, inject } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import {AbstractWebservice} from "./abstract.webservice";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class VersionWebservice extends AbstractWebservice{
  protected readonly httpClient: HttpClient;
  protected readonly httpBackend: HttpBackend;

  entity = `version`;

  constructor() {
    const httpClient = inject(HttpClient);
    const httpBackend = inject(HttpBackend);

    super();
  
    this.httpClient = httpClient;
    this.httpBackend = httpBackend;
  }

  getBackendVersion(): Observable<string> {
    return this.get(`${this.root}`, { responseType: 'text' });
  }
}
